import { mapCanBeSold } from "./mapCanBeSold";
import { mapHasAutoSubscription } from "./mapHasAutoSubscription";
export var mapShowQuickBuyButton = function mapShowQuickBuyButton(labels, shades) {
  return mapCanBeSold(labels) || Array.isArray(shades) && shades.length > 1 || mapHasAutoSubscription(labels);
};
//# sourceMappingURL=mapShowQuickBuyButton.js.map